import React from 'react';
import { connect } from 'react-redux';

import Loadable from 'react-loadable';
import PropTypes from 'prop-types';

import Spinner from '../Spinner';

import AccountLayout from '../AccountLayout';
import CenterLayout from '../CenterLayout';

import styles from './styles.scss';

function LoadableRoute({ appReady, showMenu }) {
  const LayoutType = appReady && showMenu ? AccountLayout : CenterLayout;
  return (
    <LayoutType>
      <Spinner isLoading className={styles.loader} />
    </LayoutType>
  );
}

LoadableRoute.propTypes = {
  showMenu: PropTypes.bool,
  appReady: PropTypes.bool,
};

LoadableRoute.defaultProps = {
  showMenu: false,
  appReady: false,
};

function mapStateToProps({ application }) {
  return {
    appReady: application.initialized,
  };
}

const ConnectedLoadable = connect(mapStateToProps)(LoadableRoute);

export function asLoadable(loader, { showMenu = false, ...loadableOptions } = {}) {
  const CustomLoadable = props => <ConnectedLoadable {...props} showMenu={showMenu} />;
  return Loadable({
    loader,
    loading: CustomLoadable,
    ...loadableOptions,
  });
}

export default ConnectedLoadable;



// WEBPACK FOOTER //
// ./src/app/components/LoadableRoute/index.js